import { generatePermissionForEntity } from '../util';
export const MULTI_BRANDS_MANAGEMENT_PERMISSIONS = generatePermissionForEntity('MULTI_BRANDS_MANAGEMENT');
//# sourceMappingURL=multi-brands-management.js.map